export enum Logos {
  CMAR = "/sprites.svg#cmar",
  Dalhousie = "/sprites.svg#dalhousie",
  LogoHorizontal = "/sprites.svg#logo-horizontal",
  LogoSymbol = "/sprites.svg#logo-symbol",
  LogoSymbolWhite = "/sprites.svg#logo-symbol-white",
  LogoStandard = "/sprites.svg#logo-standard",
  LogoVertical = "/sprites.svg#logo-vertical",
  Longline = "/sprites.svg#longline"
}
